import { ReactNode } from "react";
import styles from './HorizontalScroll.module.css';

export default function HorizontalScroll(props: {children: ReactNode}) {
    return (
        <div className={styles.horizontalScrollContainer}>
            <div className={styles.content}>{props.children}</div>
        </div>
    );
}